import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";

interface MainState {
  loading: boolean;
  mainDateFrom?: Date;
  mainDateTo?: Date;
  error: any;
}

const initialState: MainState = {
  loading: false,
  mainDateFrom: undefined,
  mainDateTo: undefined,
  error: undefined,
};

export const MainStatisticssSlice = createSlice({
  name: "statistics-main",
  initialState: initialState,
  reducers: {
    setStatisticDates: (
      state,
      action: PayloadAction<{ dateFrom: Date; dateTo: Date }>
    ) => {
      state.mainDateFrom = action.payload.dateFrom;
      state.mainDateTo = action.payload.dateTo;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
});

export const selectState = (state: RootState) => state.statistics.main;

export const { setError, setStatisticDates } = MainStatisticssSlice.actions;

export default MainStatisticssSlice.reducer;
